import { ApiError } from 'APP/restApi/error/ApiError';
import { WsAppApiError } from 'APP/wsApi/wsAppApi/WsAppApiError';

const MODEL_ERROR_NAME = 'MODEL_ERROR';

export class ModelError extends Error {
  public readonly name: string = MODEL_ERROR_NAME;

  constructor(message: string, public code: number, public apiError: ApiError | WsAppApiError) {
    super(message);
  }
}
